<template>
	<div>
		<div class="row mb-5">
			<div class="col-sm-12 col-md-6">
				<h1>{{ title }}</h1>
			</div>
			<div class="col-sm-12 col-md-6">
				<!-- <div class="input-group">
					<input
						type="text"
						class="form-control"
						placeholder="Search"
						aria-label="Search"
						aria-describedby="button-addon2"
					/>
					<div class="input-group-append">
						<button
							class="btn btn-outline-secondary"
							type="button"
							id="button-addon2"
						>
							<i class="fas fa-search"></i>
						</button>
					</div>
				</div> -->
			</div>
		</div>
		<hr class="mb-5" />
	</div>
</template>

<script>
import Brand from '@/services/Brand';

export default {
	name: 'Welcome',
	props: {
		title: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
h1 {
	font-family: 'Montserrat', sans-serif;
	font-size: 38px;
	line-height: 47px;
	color: #005e86;
	font-weight: 400;
}

.fa-search {
	color: #005e86;
	font-size: 20px;
}
</style>